const styles = {
  filters: {
    alignItems: 'center !important',
    borderTop: 'solid .0625rem #f5f6f7 !important',
    transition: 'all .25s ease-in-out',
    display: 'flex !important',
    padding: '0 !important',
    visibility: 'hidden !important',
    height: '0',
    opacity: '0',
    '&.filtersIsOpen': {
      height: '4.25rem',
      visibility: 'visible !important',
      opacity: '1',
    },
  },
  container: {
    display: 'flex',
    margin: '0 4.8125em  !important',
    width: '100%',
    visibility: 'hidden',
    transition: 'all .25s linear',
    transitionDelay: '.3s',
    '&.filtersIsOpen': {
      visibility: 'visible !important',
    },
  },
  merchantDetailsFilters: {
    display: 'flex',
    marginLeft: 'auto !important',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default styles;
